/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-key */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Link, useNavigate } from 'react-router-dom';
import {
  // Autocomplete,
  // Grid,
  // InputAdornment,
  // IconButton,
  // Card,
  // CardContent,
  // TextField,
  // Tooltip,
  Button,
  Chip,
  Stack,
  Typography
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import LoadingSkeleton from '../../utils/LoadingSkeleton';
import NoRowsOverlay from '../../utils/NoRowOverlay';
import SettingAction from '../../store/actions/SettingAction';
import CopyInput from '../../components/CopyInput';
import DecryptData from '../../utils/DecryptData';
import BankConfigurationDelete from './delete';
import useHasPermission from '../../utils/useHasPermission';
import { bank, show, store, update, destroy } from '../../utils/constants';

function QuickSearchToolbar() {
  // const [addOpen, setAddOpen] = useState(false);
  return (
    <Box
      className="tableTopWrap page__title"
      sx={{
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 3
      }}
    >
      <Stack direction="row" sx={{ ml: 'auto' }} spacing={2} className="MuiDataGrid-Search">
        {/* <GridToolbarQuickFilter
          quickFilterParser={(searchInput) => searchInput.split(',').map((value) => value.trim())}
          quickFilterFormatter={(quickFilterValues) => quickFilterValues.join(', ')}
          debounceMs={800} // time before applying the new quick filter value
          variant="outlined"
          size="small"
          sx={{ pb: 0, maxWidth: '275px' }}
        /> */}
        {useHasPermission(bank, store) && (
          <Button
            className="button_primary"
            variant="contained"
            size="small"
            color="secondary"
            component={Link}
            to="/settings/bank/add"
          >
            Add Bank
          </Button>
        )}
      </Stack>
    </Box>
  );
}

export default function BankConfiguration() {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });

  const [sortInfo, setSortInfo] = useState({
    sortField: '',
    sort: ''
  });
  const navigate = useNavigate();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [itemID, setItemID] = useState('');
  const [rowCountState, setRowCountState] = useState(0);
  const [data, setData] = useState([]);
  const [searchWord, setSearchWord] = useState('');
  const dispatch = useDispatch();

  const { bankListData, isLoading } = useSelector((state) => state.setting);

  useEffect(() => {
    dispatch(SettingAction.getAllBank(paginationModel, sortInfo, searchWord));
  }, [dispatch, paginationModel, sortInfo, searchWord]);

  useEffect(() => {
    if (bankListData) {
      if (bankListData.data) {
        const decryptJson = DecryptData(bankListData.data);
        setData(decryptJson);
      } else {
        setData([]);
      }
      setRowCountState((prevRowCountState) =>
        bankListData.total !== undefined ? bankListData.total : prevRowCountState
      );
    }
  }, [bankListData]);

  function maskData(dataItem) {
    const dataStr = String(dataItem);
    const visibleDigits = 4;
    const maskedSection = '*'.repeat(dataStr.length - visibleDigits);
    const visibleSection = dataStr.slice(-visibleDigits);
    return maskedSection + visibleSection;
  }
  const columns = [
    {
      field: 'unique_id',
      headerName: '',
      sortable: false,
      align: 'left',
      flex: 0.3,
      renderCell: (params) => {
        if (params && params.value) {
          return <CopyInput id={params.value} />;
        }
        return null;
      }
    },
    {
      field: 'beneficiary_bank_account',
      headerName: 'Account Number',
      sortable: false,
      flex: 1,
      renderCell: (params) => {
        if (params && params.value) {
          const maskedData = maskData(params.value);
          return (
            <Typography component="p" variant="body1">
              {maskedData}
            </Typography>
          );
        }
        return null;
      }
    },
    {
      field: 'addresses',
      headerName: 'Office Addresses',
      sortable: false,
      flex: 1,
      renderCell: (params) => {
        if (params && params.value && params.value.length > 0) {
          return (
            <Typography component="p" variant="body1">
              {params.value.join(', ')}
            </Typography>
          );
        }
        return null;
      }
    },
    {
      field: 'email',
      headerName: 'Email',
      sortable: false,
      flex: 1
    },
    // {
    //   field: 'gstin',
    //   headerName: 'GSTIN',
    //   flex: 1
    // },
    {
      field: 'phone',
      headerName: 'Phone Number',
      sortable: false,
      flex: 1
    },
    {
      field: 'status',
      headerName: 'Status',
      sortable: false,
      flex: 0.5,
      renderCell: (params) => {
        if (params && params.value) {
          return params.value === 1 ? (
            <Chip label="Active" color="success" />
          ) : (
            <Chip label="Inactive" color="lignhtwarning" />
          );
        }
        return null;
      }
    },
    useHasPermission(bank) && {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      align: 'left',
      flex: 1,
      getActions: (params) => [
        bank && useHasPermission(bank, show) ? (
          <GridActionsCellItem
            icon={<i className="icon-view" />}
            className="actionBtn"
            title="View"
            label="View"
            onClick={() => {
              navigate(`/settings/bank/view/${params.id}`);
            }}
          />
        ) : (
          <span />
        ),
        bank && useHasPermission(bank, update) ? (
          <GridActionsCellItem
            icon={<i className="icon-edit" />}
            className="actionBtn"
            title="Edit"
            label="Edit"
            onClick={() => {
              navigate(`/settings/bank/edit/${params.id}`);
            }}
          />
        ) : (
          <span />
        ),
        bank && useHasPermission(bank, destroy) ? (
          <GridActionsCellItem
            icon={<i className="icon-delete" />}
            className="actionBtn"
            title="Delete"
            label="Delete"
            onClick={() => {
              setDeleteOpen(true);
              setItemID(params.id);
            }}
          />
        ) : (
          <span />
        )
      ]
    }
  ];

  const handleSortModelChange = React.useCallback((sortModel) => {
    // Here you save the data you need from the sort model
    if (sortModel.length > 0) {
      const { field, sort } = sortModel[0];
      const sortData = {
        sortField: field,
        sort
      };
      setSortInfo(sortData);
    } else {
      dispatch(SettingAction.getAllBank(paginationModel, sortInfo));
    }
    // eslint-disable-next-line
  }, []);

  const onFilterChange = React.useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    const keyword = filterModel.quickFilterValues[0];
    setSearchWord(keyword);
    setPaginationModel({ page: 0, pageSize: 10 });
    // dispatch(PaymentAction.getAll(paginationModel, sortInfo, keyword));
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      <div className="pageTitleWrap">
        <Typography className="" component="h2" variant="h2">
          Bank Configuration
        </Typography>
      </div>
      <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
        <DataGrid
          rows={data}
          getRowId={(row) => row._id}
          rowCount={rowCountState}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10
              }
            }
          }}
          autoHeight
          sx={{ minHeight: 650, '--DataGrid-overlayHeight': '50vh' }}
          disableColumnFilter
          rowHeight={50}
          slots={{
            toolbar: QuickSearchToolbar,
            loadingOverlay: LoadingSkeleton,
            noRowsOverlay: NoRowsOverlay
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          filterMode="server"
          onFilterModelChange={onFilterChange}
          disableRowSelectionOnClick
          loading={isLoading}
        />
      </Box>
      {deleteOpen === true ? (
        <BankConfigurationDelete
          openmodal={deleteOpen}
          itemId={itemID}
          onCloseModal={() => setDeleteOpen(false)}
        />
      ) : (
        ''
      )}
    </Box>
  );
}
